import { render, staticRenderFns } from "./BackgroundColorWithHoverEffect.vue?vue&type=template&id=535806b0"
import script from "./BackgroundColorWithHoverEffect.vue?vue&type=script&lang=js"
export * from "./BackgroundColorWithHoverEffect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports